<template>
	<article class="cart-extra flex push-bottom">
		
		<div class="cart-extra__img-container">
			<img 
				:src="extra.image_url"
				:alt="extra.title"
				class="cart-extra__img img-responsive"
				loading="lazy"
			/>
		</div>

		<div class="cart-extra__meta soft-sides">
			<strong 
				v-html="extra.title"
				class="cart-extra__title"
			></strong>
			<span class="cart-extra__price"> - {{ displayPrice }}</span>

			<div 
				v-if="addedExtraToCart"
				class="cart-extra__added"
			>Product added to cart!</div>

			<div 
				v-if="hasVariations"
				class="cart-extra__variations"
			>
				<div class="cart-extra__variations__instruction">Choose from below:</div>
				<select 
					@change="handleExtraSelect"
					:value="activeVariationId"
					class="cart-extras__variations__select"
				>
					<option 
						v-for="option in extra.variations"
						:key="option.id"
						:value="option.id"
					>{{ option.extra_name }}</option>
				</select>
			</div>
		</div>

		<button
			@click="addExtra( extra )" 
			:disabled="isAdding"
			:class="{ 'is-active': isAdding }"
			class="cart-extra__add btn btn--outline"
		>&plus;</button>
	</article>
</template>


<script>
	import _isEmpty from 'lodash.isempty'
	import WpApi from '../helpers/WpApi.mjs'
	

	export default {
		name: 'CartExtra',
		props: {
			extra: {
				type: Object,
				required: true
			}
		},

		data() {
			return {
				activeVariationId: 		null,
				activeVariationName: 	'',
				addedExtraToCart: 		false,
				displayPrice: 			'',
				isAdding: 				false,
			}
		},

		computed: {
			hasVariations() {
				return ( 'object' === typeof this.extra.variations && !_isEmpty( this.extra.variations ) )
			}
		},


		beforeMount() {
			let id 		= null,
				name 	= '',
				price 	= null

			if( this.hasVariations ) {

				// @todo — organize better
				const variations 	= Object.entries( this.extra.variations ),
					variationData 	= variations[0][1]

				id 		= variationData.id
				name 	= variationData.extra_name
				price 	= variationData.price_pretty

			} else {
				id 		= this.extra.id
				name 	= this.extra.title
				price 	= this.extra.price_pretty
			}

			this.activeVariationId 		= id
			this.activeVariationName 	= name
			this.displayPrice 			= price
		},


		methods: {
			addExtra() {
				this.addedExtraToCart = false
				
				// avoid submitting twice
				if( this.isAdding ) {
					return
				}

				this.isAdding = true

				WpApi
					.addProductToCart({
						product_id: 	this.extra.id,
						quantity: 		1,
						variation_id: 	this.activeVariationId,
					}).then( response => {
						this.$emit( 'handle_added_extra', response )
						this.isAdding = false
						this.addedExtraToCart = true
					})
			},


			handleExtraSelect( e ) {
				const variationId 	= parseInt( e.target.value ),
					variation 		= this.extra.variations[ variationId ]

				this.activeVariationId 		= variation.id
				this.activeVariationName 	= variation.extra_name
				this.displayPrice 			= variation.price_pretty
			}
		},	
	}
</script>